<style src="./BoardHeader.scss" lang="scss"></style>
<template>
  <header class="board-header">
    <div class="identification">
      <span class="stagename">{{ modalDetails.stage.name }}</span>
      <h4 class="client">{{ modalDetails.event.name }}</h4>
    </div>
    <div
      v-if="!!modalDetails.openedBy"
      class="taskinfo">
      <span
        class="infos user"
        title="Tarefa aberta por:">
        <icon-user class="icon" />
        {{ modalDetails.openedBy.user.name }}
      </span>

      <span
        class="infos"
        title="Data de abertura">
        <icon-calendar class="icon" />
        {{ modalDetails.openedBy.open | DateTime }}
      </span>
    </div>
  </header>
</template>

<script>
import moment from 'moment'
import { IconCalendar, IconUser } from '@/components/primitives/icons'

export default {
  name: 'BoardHeader',
  components: {
    IconCalendar,
    IconUser
  },
  props: {
    modalDetails: {
      default: () => ({})
    }
  },
  filters: {
    DateTime (dt) {
      return moment(dt).format(`DD/MM/YYYY [às] HH:mm`)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/board/components/board-details/components/board-header/BoardHeader.vue